module.exports = __webpack_public_path__ + "img/icon_map_10_on_111.55ac0078.png";